import { createAction } from 'redux-act';

export const updateFormData = createAction('checkout/UPDATE_FORM_DATA');
export const clearFormData = createAction('checkout/CLEAR_FORM_DATA');
export const updatePayments = createAction('checkout/UPDATE_PAYMENTS');
export const setBookingClientRequestId = createAction('checkout/SET_BOOKING_CLIENT_REQUEST_ID');
export const setBookingChannel = createAction('checkout/SET_BOOKING_CHANNEL');
